import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NewAssetWizardService {

  public assetList: any = [
    {
      name: "Text",
      displayName: "Text",
      color: "#F2D946",
      icon: "md-create",
      description: "This media type allows you to insert text into the scene. You can use this to create written instructions in a scene or provide an explanation of items in a scene. Just like all other media types, you can manage actions on this text media to show or hide an object, toggle visibility of another object, interact with videos, or even link to another scene. A common use of actions on media is to make the text interactable for the learner by using the word “Enter” to enter the linked scene. You can also change the text properties and enable text to speech.",
      gif: ""
    },
    {
      name: "Image",
      displayName: "Image",
      color: "#17A1A8",
      icon: "image",
      description: "This media type allows you to insert images. With manage actions on an image, you can enable end users to interact with images by using them to show or hide an object, toggle visibility of another object, play, toggle, or stop other media, or even linking another scene. For example, you may use an image as a way to transport your end user to a new scene. The image used could be a still image of the new scene or even as simple as using a star to take the end user to the start screen. Supported image types are jpeg, gif and png.",
      gif: ""
    },
    {
      name: "Video",
      displayName: "Video",
      color: "#0ABFF2",
      icon: "film",
      description: "This media type allows you to insert a video into the scene as a floating box. A common use of this media type is to insert a video explaining a process more in depth. An example of this could be a scene with multiple machines, each with their own video explaining how the tool works. You can add from the media management page if you have already uploaded your media or upload from your computer. Uploading may take some time depending on file size, if you do not mind a lower resolution quality, you can choose to compress the video, which will reduce the time to upload. Supported video file types are mp4 and mov.",
      gif: ""
    },
    {
      name: "Audio",
      displayName: "Audio",
      color: "#5821A6",
      icon: "musical-notes",
      description: "This option allows you to add audio media to this scene. You can use this to insert things like voice instructions, examples of sounds found in a certain area, voice clips on how to pronounce something etc. You can add from the media management page if you have already uploaded your media or upload from your computer. A common use of audio is to introduce the scene, guiding the end user to look around the scene. Supported audio file types are mp3, wav and ogg.",
      gif: ""
    },
    {
      name: "QuestionSet",
      displayName: "Quiz",
      color: "#F22EAE",
      icon: "school",
      description: "This option allows you to insert a quiz or even single question. Quizzes are an excellent way to assess competency in your end users. A quiz offers multiple questions to your learner, all questions are fully customizable with the option of adding actions to each response on each question or the quiz as a whole based on their performance. When creating a quiz, you can customise a cover page, the questions (up to 15 questions), confirmation page, and the results page.",
      gif: ""
    },
    {
      name: "Invisible",
      displayName: "Selection",
      color: "#1828AF",
      icon: "color-wand",
      description: "The selection tool allows you to place an invisible shape in the scene. You can manage actions for this selection that enable you to show or hide an object, toggle visibility of something in the scene, interact with media, or link to another scene. For example, you can place a selection over a door so that when the learner clicks on the door, it takes them to the next scene. Another common use is to identify items within the background, such as safety hazards in a construction site.",
      gif: ""
    },
    {
      name: "HotSpot",
      displayName: "HotSpot",
      color: "#ff2b2b",
      icon: "md-radio-button-on",
      description: " This is an information icon. You can insert a hotspot and manage actions to link another type of media (i.e. image, text, etc.).  When the learner interacts with the hotspot the linked media will pop up, hide, toggle on and off, or play. You can manage which media is linked to the hotspot and the actions that are triggered from “Manage Actions” section. For example, you can place a hotspot next to an item in the scene to provide the learner with additional information that can be toggled on or off.",
      gif: ""
    },
    {
      name: "Model3D",
      displayName: "3D Model",
      color: "#A60F71",
      icon: "cube",
      description: "This media type allows you to insert a 3D model into the scene. Just like all other media types, you can manage actions on this media type to interact with other media types such as hiding or showing an object or linking to another scene. Supported file types for 3D models are glb.",
      gif: ""
    }
  ];

  public selectedAsset: string = "Text";

  constructor() { }

  getCurrentAssetFromList() {
    return this.assetList.filter(x => x.name == this.selectedAsset)[0];
  }

}
